import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AppHttpService } from 'src/app/app-http.service';
import { ModalChoiceComponent } from '../modal-choice/modal-choice.component';
import { ModalMensageComponent } from '../modal-mensage/modal-mensage.component';

@Component({
  selector: 'app-validatecode',
  templateUrl: './validatecode.component.html',
  styleUrls: ['./validatecode.component.css']
})
export class ValidatecodeComponent implements OnInit {

  constructor(private router: Router, public dialog: MatDialog, public http:AppHttpService) { }
  ngOnInit(): void {
  }

  otp: string = "";
  showOtpComponent = true;

  onOtpChange(otp: string) {
    this.otp = otp;
  }


  @ViewChild('ngOtpInput', { static: false }) ngOtpInput: any;
  config = {
    allowNumbersOnly: false,
    length: 8,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
    inputStyles: {
      'width': '50px',
      'height': '50px',
      'border-top': 'none',
      'border-left': 'none',
      'border-right': 'none',
      'border-radius': '0'
    }
  };

  setVal(val: string) {
    this.ngOtpInput.setValue(val);
  }

  toggleDisable() {
    if (this.ngOtpInput.otpForm) {
      if (this.ngOtpInput.otpForm.disabled) {
        this.ngOtpInput.otpForm.enable();
      } else {
        this.ngOtpInput.otpForm.disable();
      }
    }
  }

  onConfigChange() {
    this.showOtpComponent = false;
    this.otp = "";
    setTimeout(() => {
      this.showOtpComponent = true;
    }, 0);
  }


  validateCode(pageName: string){
    this.http.getVerificationCodeValidation(localStorage["userId"], this.otp).subscribe((data: any) => {
     localStorage['validateCode'] = this.otp;
      this.router.navigate([pageName]);
    }, ((error: any) => {
      console.log(error)
      const dialogRef = this.dialog.open(ModalMensageComponent,
        {
          data: {
            msg: error.error[0].message
          }
        });
    }));

  }

  openDialog() {
    const dialogRef = this.dialog.open(ModalChoiceComponent,
      {

        data: {
          email: localStorage["email"] == 'undefined' ? undefined : localStorage["email"],
          phone: localStorage["phoneNumber"] == 'undefined' ? undefined : localStorage["phoneNumber"],
		  formaEnvio: localStorage["formaEnvio"] == 'undefined' ? undefined : localStorage["formaEnvio"],
		  formaEnvioDigitoVerificador: localStorage["formaEnvioDigitoVerificador"] == 'undefined' ? undefined : localStorage["formaEnvioDigitoVerificador"]
        }
      });

  }





}
